import { styled, XStack, YStack } from 'tamagui';

export const CoordinatesPopOver = styled(YStack, {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'white',
  paddingHorizontal: '$5',
  paddingVertical: '$4',
  paddingBottom: '$6',
  borderTopLeftRadius: '$4',
  borderTopRightRadius: '$4',
  shadowColor: '$shadowColor',
  shadowOffset: { width: 0, height: -2 },
  shadowOpacity: 0.1,
  shadowRadius: 8,
  elevation: 5,
  gap: '$4',
  zIndex: 100,
});

export const PinModalHeader = styled(XStack, {
  position: 'absolute',
  zIndex: 100,
  width: '100%',
  backgroundColor: 'white',
  alignItems: 'center',
  padding: '$2',
});
